import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { ROUTE_DOCS_STEWARDSHIP } from '@/common/constants';
import { IResponsibleEmployee } from '@/features/stewardship/models/IStewardship';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

type Props = {
  employees: IResponsibleEmployee[];
};

export const TableEmployeesList: FC<Props> = ({ employees = [] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { region_id, district_id, lang } = useParams();

  const getFullName = (employee: IResponsibleEmployee) => {
    const parts = [
      employee.last_name,
      employee.first_name,
      employee.middle_name,
    ].filter(Boolean);
    return parts.join(' ');
  };

  const handleRowClick = (employee: IResponsibleEmployee) => {
    navigate({
      pathname: `/${lang}/${ROUTE_DOCS_STEWARDSHIP}/${region_id}/${district_id}/${employee.user_id}`,
      search: window.location.search,
    });
  };

  return (
    <div className="w-full rounded-10 border bg-white overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-100 hover:bg-gray-100">
            <TableHead className="py-3 !max-w-[50px] w-[50px]">
              <p>№</p>
            </TableHead>
            <TableHead className="py-3">
              <p>{t('responsible.employee.inspector')}</p>
            </TableHead>
            <TableHead className="py-3">
              <p>{t('organization')}</p>
            </TableHead>
            <TableHead className="py-3">
              <p>{t('position')}</p>
            </TableHead>
            <TableHead className="py-3">
              <p>{t('farmers.count')}</p>
            </TableHead>
            <TableHead className="py-3">
              <p>{t('projects.count')}</p>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {employees.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center py-8 text-gray-500">
                {t('no.data')}
              </TableCell>
            </TableRow>
          ) : (
            employees.map((employee, index) => (
              <TableRow
                key={employee.id || `${employee.user_id}-${index}`}
                className="hover:bg-gray-50 cursor-pointer"
                onClick={() => handleRowClick(employee)}
              >
                <TableCell className="py-3 !max-w-[50px] w-[50px]">
                  <p>{index + 1}</p>
                </TableCell>
                <TableCell className="py-3">
                  <p className="font-medium">{getFullName(employee)}</p>
                </TableCell>
                <TableCell className="py-3">
                  <p>{employee.organization_name || '-'}</p>
                </TableCell>
                <TableCell className="py-3">
                  <p>{employee.position || '-'}</p>
                </TableCell>
                <TableCell className="py-3">
                  <p>{employee.farmers_count || '-'}</p>
                </TableCell>
                <TableCell className="py-3">
                  <p>{employee.projects_count || '-'}</p>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};
